"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BranchCreateRequestSchema () {
        return BranchCreateRequestSchema;
    },
    get BranchListResponseSchema () {
        return BranchListResponseSchema;
    },
    get BranchSchema () {
        return BranchSchema;
    },
    get BranchStatusRequestSchema () {
        return BranchStatusRequestSchema;
    },
    get BranchUpdateRequestSchema () {
        return BranchUpdateRequestSchema;
    }
});
const _zod = require("zod");
const _clinicprofile = require("./clinic-profile");
const BranchSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    version: _zod.z.number().int().min(1),
    isActive: _zod.z.boolean(),
    name: _zod.z.string().min(1),
    addressLine1: _zod.z.string().min(1),
    addressLine2: _zod.z.string().min(1).nullable(),
    city: _zod.z.string().min(1),
    province: _zod.z.string().min(1).nullable(),
    postalCode: _zod.z.string().regex(_clinicprofile.CLINIC_POSTAL_CODE_PATTERN).nullable(),
    phone: _zod.z.string().min(1).nullable(),
    updatedAt: _zod.z.string().datetime({
        offset: true
    })
}).strict();
const BranchListResponseSchema = _zod.z.object({
    items: _zod.z.array(BranchSchema)
}).strict();
/**
 * The `version` the client last saw for the row it is writing. A stale one
 * gets 409 `BRANCH_VERSION_CONFLICT`.
 */ const versionToken = _zod.z.number({
    message: 'version must be a number.'
}).int({
    message: 'version must be a whole number.'
}).min(1, {
    message: 'version must be at least 1.'
});
const BranchCreateRequestSchema = _zod.z.object(_clinicprofile.clinicProfileShape).strict();
const BranchUpdateRequestSchema = _zod.z.object({
    version: versionToken,
    ..._clinicprofile.clinicProfileShape
}).strict();
const BranchStatusRequestSchema = _zod.z.object({
    version: versionToken,
    isActive: _zod.z.boolean({
        message: 'isActive must be true or false.'
    })
}).strict();
